import {Routes, Route,BrowserRouter} from 'react-router-dom';
import { useAdminAuthContext } from './administrator/admin/useAdminAuthContext';
import { AdminLogin } from './administrator/admin/AdminLogin';
import { AdminDashboard } from './administrator/admin/AdminDashboard';
import { AdminManage } from './administrator/admin/AdminManage';
import { AdminCreate } from './administrator/admin/AdminCreate';
import { AdminStoreManage } from './administrator/store/AdminStoreManage';
import { AdminEmployeeManage } from './administrator/employee/AdminEmployeeManage';


import { EmployeeLogin } from './employee/EmployeeLogin';
import { EmployeeDashboard } from './employee/EmployeeDashboard';
import { useEmployeeAuthContext } from './employee/useEmployeeAuthContext';
import { AdminTimeReportManage } from './administrator/timereport/AdminTimeReportManage';
import AdminTimeReportSimple from './administrator/timereport/AdminTimeReportSimple';
import { AdminChangeRequestManage } from './administrator/changerequest/AdminChangeRequestManage';
import AdminTimeReportRead from './administrator/timereport/AdminTimeReportRead';

function App() {

  const {admin} = useAdminAuthContext();


  const { employee } = useEmployeeAuthContext();

  return (
    <BrowserRouter>
          <Routes>

          <Route path='/' element={<EmployeeLogin />} />

           {/* Employee Dashboard */}

              <Route path="/employee/dashboard"
                element={
                  employee
                    ?
                    <EmployeeDashboard />
                    :
                    <EmployeeLogin />
                }
              />

            
                {/* Admin related routes */}
                <Route path='/administrator/login' element={<AdminLogin />} />
                <Route path='/administrator/dashboard' element=
                {
                  admin ?
                        <AdminDashboard />
                        :
                        <AdminLogin />
                } />
                <Route path='/administrator/admin/manage' element=
                {
                  admin ?
                        <AdminManage />
                        :
                        <AdminLogin />
                } />
                <Route path='/administrator/admin/create' element=
                {
                  admin ?
                        <AdminCreate />
                        :
                        <AdminLogin />
                } />

              <Route path='/administrator/store/manage' element=
                {
                  admin ?
                        <AdminStoreManage />
                        :
                        <AdminLogin />
                } />

              <Route path='/administrator/employee/manage' element=
                {
                  admin ?
                        <AdminEmployeeManage />
                        :
                        <AdminLogin />
                } />

              <Route path='/administrator/timereport/manage' element=
                {
                  admin ?
                        <AdminTimeReportManage />
                        :
                        <AdminLogin />
                } />

                <Route path='/administrator/timereport/simple' element=
                {
                  admin ?
                        <AdminTimeReportSimple />
                        :
                        <AdminLogin />
                } />

                <Route path='/administrator/timereport/read' element=
                {
                  admin ?
                        <AdminTimeReportRead />
                        :
                        <AdminLogin />
                } />

              <Route path='/administrator/changerequest/manage' element=
                {
                  admin ?
                        <AdminChangeRequestManage />
                        :
                        <AdminLogin />
                } />




          </Routes>
    </BrowserRouter>
  );
}

export default App;
